import React from 'react';
import { oohData } from '../utils/oohData';
import { EyeIcon, ClockIcon } from 'lucide-react';
export const ViewingContext: React.FC = () => {
  const {
    viewingContext
  } = oohData;
  return <div className="bg-white rounded-xl shadow-sm border-l-4 border-l-[#1E3A8A] overflow-hidden" data-id="element-261">
      <div className="p-6 flex flex-col md:flex-row md:items-center justify-between gap-6" data-id="element-262">
        <div className="flex-1" data-id="element-263">
          <div className="flex items-center space-x-2 mb-3" data-id="element-264">
            <EyeIcon className="export-icon-down w-5 h-5 text-[#1E3A8A]" data-id="element-265" />
            <h3 className="font-semibold text-gray-900" data-id="element-266">Viewing Context</h3>
          </div>
          <p className="text-sm text-gray-700 leading-relaxed" data-id="element-267">
            {viewingContext.description}
          </p>
        </div>

        <div className="flex flex-wrap gap-3 md:justify-end" data-id="element-268">
          {viewingContext.modes.map((mode, idx) => <div key={idx} className="flex items-center space-x-2 bg-gray-50 border border-gray-100 px-3 py-2 rounded-lg" data-id="element-269">
              <ClockIcon className="export-icon-down w-4 h-4 text-gray-400" data-id="element-270" />
              <div className="flex flex-col" data-id="element-271">
                <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider leading-none mb-1" data-id="element-272">
                  {mode.label}
                </span>
                <span className="text-xs font-medium text-gray-900 leading-none" data-id="element-273">
                  {mode.time}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};